/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json
import api from '../../api'

const state = { 
} 
const mutations = { 
} 
const getters = { 
}

const actions = {
  getProduct({ rootState }, opt) { // 获取产品信息
    return new Promise((resolve, reject) => {
        axios.post(`${config.api.reqApi}/api/product/GetByCompId`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            };
        }).catch((err) => {
            console.log(err.response.data);
        });
    });
  },
  getProductMes({ rootState }, opt) { // 获取产品留言
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProductComment/GetByProId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delProductMes({ rootState }, id) { // 删除产品留言
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/ProductComment?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  sendProductMes({ rootState }, opt) { // 回复产品留言
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProductComment`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getProductApply({ rootState }, opt) { // 获取用户申请记录
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProductApply/GetByProId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}